import moment from 'moment';

import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import nullBind from 'utils/functions/nullBind.util';

const getLockEnabled = nullBind(getAnyOrNull, 'response.enabled_pin_access');
const getInactivityDuration = nullBind(getAnyOrVoid, 'response.calendar_allowed_inactivity_duration');

const tristate = (value) => (value === true || value === false ? value : null);

const reduceThresholdAndLockSetting = (oldState, data) => {
  let state = oldState;

  const lockEnabled = tristate(getLockEnabled(data));
  const oldLockEnabled = oldState.lockEnabled;

  if (lockEnabled !== oldLockEnabled) {
    // don't alter state if not necessary
    state = { ...state, lockEnabled };
  }

  // check if valid duration is provided to calculate the threshold
  const duration = moment.duration(getInactivityDuration(data));
  if (!duration.isValid()) {
    return state;
  }

  // even if duration is valid, the resulting threshold may still be not worth altering state, so double-check it
  const threshold = duration.asMilliseconds();
  if (threshold > 0 && threshold !== state.threshold) {
    state = { ...state, threshold };
  }

  return state;
};

// noinspection JSUnusedGlobalSymbols
export default reduceThresholdAndLockSetting;
